import { Button, ButtonProps } from '@orbita-ui/core';
import styled from 'styled-components';
import { ThemePrisma } from '@orbita-ui/brand';

const getBackgroundColor = (
  color: 'primary' | 'destructive' | 'inverted',
  variant?: 'filled' | 'outline' | 'ghost',
): string => {
  if (!variant || variant === 'filled') {
    switch (color) {
      case 'primary':
        return `${ThemePrisma.colors.pink[3]} !important`;
      case 'destructive':
        return `${ThemePrisma.colors.red[2]} !important`;
      case 'inverted':
        return `${ThemePrisma.colors.pink[3]} !important`;
    }
    return 'transparent';
  }
};

const StyledPlButton = styled(Button)`
  cursor: wait !important;
  span {
    border-radius: 8px;
  }
  &[color='primary'] {
    &:disabled {
      color: ${ThemePrisma.colors.pink[3]} !important;
      background-color: ${(props) => getBackgroundColor('primary', props.variant)};
      border-color: ${ThemePrisma.colors.pink[3]} !important;

      span {
        background: ${ThemePrisma.colors.pink[3]};
      }
    }
  }
  &[color='destructive'] {
    background-color: ${(props) => getBackgroundColor('destructive', props.variant)};
    border-color: ${ThemePrisma.colors.red[2]} !important;
    color: ${ThemePrisma.colors.red[2]} !important;

    span {
      background: ${ThemePrisma.colors.red[2]};
    }
  }
`;

export const ButtonPlaceholder = ({ children, ...props }: ButtonProps) => {
  return (
    <StyledPlButton disabled={true} {...props}>
      <span>{children}</span>
    </StyledPlButton>
  );
};
